import useTranslation from 'next-translate/useTranslation';
import * as LocalStorage from '../../utils/localStorage';
import { addCoupon } from '../../api/legacy';
import useMessageHandler from '../../hooks/useMessageHandler';
import Currency from '../../utils/currency';
import { CouponType } from '../../types/payment';

const LOCAL_STORAGE_KEY = 'coupon';

interface UseCoupon {
  rememberCoupon: (code: string) => void;
  addCouponToUser: () => void;
}

const useCoupon = (): UseCoupon => {
  const { t } = useTranslation('common');
  const { setSuccess, setError } = useMessageHandler();

  const rememberCoupon = (code: string) => {
    LocalStorage.saveItem(LOCAL_STORAGE_KEY, code);
  };

  const unsetCoupon = () => {
    LocalStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  const addCouponToUser = async () => {
    const code = LocalStorage.getItem(LOCAL_STORAGE_KEY);
    if (!code) return;

    try {
      const data = await addCoupon(code);
      setSuccess(
        data.type === CouponType.FIXED_AMOUNT && data.amount
          ? t('Promo.addSuccessAmountOff', { amount: Currency.format(data.amount) })
          : t('Promo.addSuccessPercentageOff', { percentage: data.value }),
      );
    } catch (err: any) {
      setError(err);
    } finally {
      unsetCoupon();
    }
  };

  return { rememberCoupon, addCouponToUser };
};

export default useCoupon;
